import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const UserSettingsContainer = styled.div`
	margin-top: 0;
`;

const Box = styled.div`
	padding: 24px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.XL}px;
`;

export { UserSettingsContainer, Box };
